module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/f8fad89ac0b44e917c2b21209994e00f.png";